// import './services.css';
// import { BiCheck } from 'react-icons/bi';
// import { motion } from 'framer-motion';


// const Services = () => {
//   return (
//     <section id='services'>
      
//       <motion.div
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: true, amount: 0.5 }}
//         transition={{ duration: 0.5 }}
//         variants={{
//           hidden: { opacity: 0, y: -50 },
//           visible: { opacity: 1, y: 0 },
//         }}
//       >
//         <h5>What I Offer</h5>
//         <h2>Services</h2>
//       </motion.div>

//       <div className="container services-container">

//         {/* UI/UX CONTAINER */}
        
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true, amount: 0.5 }}
//           transition={{ duration: 0.5 }}
//           variants={{
//             hidden: { opacity: 0, y: 50 },
//             visible: { opacity: 1, y: 0 },
//           }}>
//           <article className='service'>
//             <div className="service-head">
//               <h3>Frontend Development</h3>
//             </div>

//             <ul className='service-list'>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Collaboration with designers.</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Responsive web design</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Optimization of website performance.</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Component-based architecture in frameworks like react.</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Version control systems like Git to collaborate and manage code.</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Proficiency in debugging code, and identifying and fixing issues.</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Effective communication, problem-solving, teamwork, and time management.</p>
//               </li>
//             </ul>
//           </article>
//         </motion.div>

//         {/* WEB DEV CONTAINER */}
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true, amount: 0.5 }}
//           transition={{ delay: 0.2,  duration: 0.5 }}
//           variants={{
//             hidden: { opacity: 0, y: 50 },
//             visible: { opacity: 1, y: 0 },
//           }}>
//           <article className='service web'>
//             <div className="service-head">
//               <h3>Office Software Skills</h3>
//             </div>

//             <ul className='service-list'>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Word Processing</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Spreadsheets</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Presentations</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Data Entry and Management</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Document Collaboration</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Basic Graphic Design</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Proofreading and Editing</p>
//               </li>

//             </ul>
//           </article>
//         </motion.div>


//         {/* <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true, amount: 0.5 }}
//           transition={{ delay: 0.4,  duration: 0.5 }}
//           variants={{
//             hidden: { opacity: 0, y: 50 },
//             visible: { opacity: 1, y: 0 },
//           }}>
//           <article className='service'>
//             <div className="service-head">
//               <h3>Content Creation</h3>
//             </div>

//             <ul className='service-list'>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
//               </li>
//               <li>
//                 <BiCheck className='service-list-icon'/>
//                 <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
//               </li>
//             </ul>
//           </article>
//         </motion.div> */}

//       </div>
//     </section>
//   );
// }

// export default Services;


import './services.css';
import { BiCheck } from 'react-icons/bi';
import { motion } from 'framer-motion';

const fadeUp = (delay = 0) => ({
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay, ease: 'easeOut' },
  },
});

const Services = () => {
  return (
    <section id="services">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
        variants={fadeUp(0)}
        className="text-center mb-12"
      >
        <h5 className="text-gray-400 uppercase tracking-wider">What I Offer</h5>
        <h2 className="text-3xl font-bold">Services</h2>
      </motion.div>

      <div className="container services-container grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* FRONTEND DEVELOPMENT */}
        <motion.article
          className="service card"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          variants={fadeUp(0.1)}
        >
          <div className="service-head">
            <h3>Frontend Development</h3>
          </div>

          <ul className="service-list">
            <li><BiCheck className="service-list-icon" /><p>Responsive, accessible, and pixel-perfect UI development using React, Next.js, and TypeScript.</p></li>
            <li>
              <BiCheck className='service-list-icon'/>
              <p>Component-based architecture in frameworks like react.</p>
            </li>
            <li><BiCheck className="service-list-icon" /><p>Performance optimization through lazy loading, caching, and code-splitting.</p></li>
            <li><BiCheck className="service-list-icon" /><p>Integration of RESTful and WebSocket APIs for dynamic, real-time interfaces.</p></li>
            <li><BiCheck className="service-list-icon" /><p>State management with Redux and Context API for scalable app architecture.</p></li>
            <li><BiCheck className="service-list-icon" /><p>WCAG-compliant design and animation using Framer Motion for smooth UX.</p></li>
            {/* <li>
              <BiCheck className='service-list-icon'/>
              <p>Version control systems like Git to collaborate and manage code.</p>
            </li> */}
            <li>
              <BiCheck className='service-list-icon'/>
              <p>Proficiency in debugging code, and identifying and fixing issues.</p>
            </li>
          </ul>
        </motion.article>

        {/* BACKEND DEVELOPMENT */}
        <motion.article
          className="service card"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          variants={fadeUp(0.2)}
        >
          <div className="service-head">
            <h3>Backend Development</h3>
          </div>

          <ul className="service-list">
            <li><BiCheck className="service-list-icon" /><p>API development using Node.js, Express.js, and TypeScript for scalable systems.</p></li>
            <li><BiCheck className="service-list-icon" /><p>Database design and management using MongoDB, PostgreSQL, and Sequelize ORM.</p></li>
            <li><BiCheck className="service-list-icon" /><p>JWT-based authentication and role-based access control for secure applications.</p></li>
            <li><BiCheck className="service-list-icon" /><p>Integrated third-party services (Cloudinary, Paystack, Firebase, Nodemailer).</p></li>
            <li><BiCheck className="service-list-icon" /><p>Optimized backend architecture with error handling, rate limiting, and Docker containerization.</p></li>
          </ul>
        </motion.article>

        {/* OFFICE SOFTWARE SKILLS */}
        <motion.article
          className="service card"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          variants={fadeUp(0.3)}
        >
          <div className="service-head">
            <h3>Office Software Skills</h3>
          </div>

          <ul className="service-list">
            <li><BiCheck className="service-list-icon" /><p>Word processing and professional documentation.</p></li>
            <li><BiCheck className="service-list-icon" /><p>Spreadsheet data analysis and management.</p></li>
            <li><BiCheck className="service-list-icon" /><p>Presentations and visual reporting.</p></li>
            <li><BiCheck className="service-list-icon" /><p>Basic graphic design and document editing.</p></li>
            <li><BiCheck className="service-list-icon" /><p>Team collaboration and data entry accuracy.</p></li>
          </ul>
        </motion.article>
      </div>
    </section>
  );
};

export default Services;